import translation from './translation.json';

export const en = {
  translation,
};
